import React, { memo, useCallback, useState } from "react";
import { DefaultText } from "theme/GlobalElements";
import styled from "styled-components/macro";
import { Counter } from "features/cart/DesktopCartButton";
import { toRem } from "theme/Breakpoints";
import { MenuIcon } from "components/AppHeader/Mobile/MobileHeader";
import { MdCompareArrows } from "react-icons/md";
import MobileCartDropdown from "features/cart/MobileCartDropdown";
import { Wrapper } from "./BottomBarItem";
import userStorage from "store/UserStorage";
import { selectProductsToCompareUpdate, update } from "features/compare/compareSlice";
import { useDispatch, useSelector } from "react-redux";

const MobileCompareButton = () => {
  const [isToggled, setToggled] = useState(false);
  const productsToCompare = userStorage.getStoredForCompare();
  const checkForUpdate = useSelector(selectProductsToCompareUpdate);

  const dispatch = useDispatch();

  const onToggleClick = () => {
    setToggled(!isToggled);
  };

  const onClickOutside = useCallback(() => {
    setToggled(false);
  }, []);

  const updateCallback = useCallback(() => {
    console.log(test);
  }, []);

  const removeElementWithId = (id: string) => {
    dispatch(update(true));
    userStorage.removeItemForCompare(id);
    dispatch(update(false));
  };

  return (
    <Wrapper>
      {isToggled && (
        <MobileCartDropdown
          showCount={false}
          emptyMessage="Не са добавени продукти за сравнение"
          actionButtonTitle="Сравни"
          actionButtonRoute="/compare"
          removeElementWithId={removeElementWithId}
          onClickOutside={onClickOutside}
          updateCallback={updateCallback}
          items={productsToCompare.map((product: any) => {
            return { product };
          })}
        />
      )}
      <Container onClick={onToggleClick}>
        <MenuIcon>
          <MdCompareArrows color="white" size="2em" />
        </MenuIcon>
        <MobileCounter>
          <DefaultText color={"white"}>{productsToCompare.length}</DefaultText>
        </MobileCounter>
      </Container>
    </Wrapper>
  );
};

const Container = styled.div`
  height: ${toRem(50)};
  width: ${toRem(50)};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const MobileCounter = styled(Counter)`
  top: 3px;
  right: 3px;
`;

export default memo(MobileCompareButton);
